.fw{border:1px solid #ddd;}